exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "video[data-v-522708ef]{width:100%}@media (max-width:47.99em){video[data-v-522708ef]{--gridPadding:30px;width:calc(100% + var(--gridPadding) * 2);margin-left:calc(-1 * var(--gridPadding));border-radius:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-522708ef","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/vuejs/frontend/2023-launch/components/AppVideoPlayerwithObserver.vue
// module id = d5/a
// module chunks = 4